import { useState, useCallback, useMemo } from 'react';

/**
 * Hook for managing selected class section across the teacher dashboard.
 * Persists selection in sessionStorage.
 */
const useClassContext = () => {
  const [selectedClassId, setSelectedClassIdState] = useState(() => {
    const stored = sessionStorage.getItem('selectedClassId');
    return stored ? parseInt(stored, 10) : null;
  });

  const setSelectedClassId = useCallback((classId) => {
    if (classId === null || classId === undefined || classId === '') {
      sessionStorage.removeItem('selectedClassId');
      setSelectedClassIdState(null);
    } else {
      const id = parseInt(classId, 10);
      sessionStorage.setItem('selectedClassId', id.toString());
      setSelectedClassIdState(id);
    }
  }, []);

  const isAllClasses = selectedClassId === null;

  const filteredApiParams = useMemo(() => {
    if (isAllClasses) return '';
    return `?class_section_id=${selectedClassId}`;
  }, [isAllClasses, selectedClassId]);

  const appendClassFilter = useCallback((url) => {
    if (isAllClasses) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}class_section_id=${selectedClassId}`;
  }, [isAllClasses, selectedClassId]);

  return {
    selectedClassId,
    setSelectedClassId,
    isAllClasses,
    filteredApiParams,
    appendClassFilter,
  };
};

export default useClassContext;
